import { createAction } from '@reduxjs/toolkit';

export const QUERY_SURVEY_AI = 'QUERY_SURVEY_AI';
export const QUERYING_SURVEY_AI = 'QUERYING_SURVEY_AI';
export const QUERY_SURVEY_AI_SUCCEEDED = 'QUERY_SURVEY_AI_SUCCEEDED';
export const QUERY_SURVEY_AI_FAILED = 'QUERY_SURVEY_AI_FAILED';

export const querySurveyAi = createAction(QUERY_SURVEY_AI);
export const queryingSurveyAi = createAction(QUERYING_SURVEY_AI);
export const querySurveyAiSucceeded = createAction(QUERY_SURVEY_AI_SUCCEEDED);
export const querySurveyAiFailed = createAction(QUERY_SURVEY_AI_FAILED);
